import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./LandingPage.css";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

const LandingPage = () => {
  const [searchTerm, setSearchTerm] = React.useState();
  const navigate = useNavigate();

  return (
    <section className="hero">
      <div className="secondary-bg text-center py-5">
        <div className="container">
          <h1 className="display-3 fw-bold text-white">
            Welcome to HelpingHand
          </h1>
          <p className="lead text-white">
            Connecting Impoverished Texans with Health and Wellness Resources
          </p>
          <Link
            to="/counties"
            className="btn btn-light btn-lg"
            id="get-started"
          >
            Get Started
          </Link>
          <div className="d-flex justify-content-center">
            <InputGroup className="mb-3 mt-3 w-75" id="search">
              <Form.Control
                size="lg"
                type="text"
                placeholder="County, Nonprofit, Centers..."
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <Button
                variant="primary"
                onClick={() => navigate(`/search/${searchTerm}`)}
              >
                Search
              </Button>
            </InputGroup>
          </div>
        </div>
      </div>
      <div className="container d-flex flex-wrap gap-3 justify-content-center">
        <Link to="/counties" className="card-link">
          <Card className="hero-card" id="to-counties">
            <Card.Body>
              <Card.Title>Texas Counties</Card.Title>
              <Card.Text>
                Explore the counties in Texas that are in need of assistance.
              </Card.Text>
            </Card.Body>
          </Card>
        </Link>
        <Link to="/nonprofits" className="card-link">
          <Card className="hero-card" id="to-nonprofits">
            <Card.Body>
              <Card.Title>Non-Profits</Card.Title>
              <Card.Text>
                Discover non-profits dedicated to improving community
                well-being.
              </Card.Text>
            </Card.Body>
          </Card>
        </Link>
        <Link to="/healthcenters" className="card-link">
          <Card className="hero-card" id="to-centers">
            <Card.Body>
              <Card.Title>Health and Wellness</Card.Title>
              <Card.Text>
                Find local health and wellness centers offering support.
              </Card.Text>
            </Card.Body>
          </Card>
        </Link>
      </div>
    </section>
  );
};

export default LandingPage;
